export const TOKEN_KEY = 'bkl_tkn';
export const EXP_KEY = 'bkl_exp';
// TODO: Check if this works in Safari browser
export const set = (key, val) => sessionStorage.setItem(key, val);
export const get = key => sessionStorage.getItem(key);
export const del = key => sessionStorage.removeItem(key);
